import React from 'react';
import clsx from 'clsx';
import { ScheduleItem, ScheduleItemContract } from '@app-types';
import styles from './SchedulerTableCells.module.css';

const ContractNumberCell: React.FC<{
  scheduleItem: ScheduleItem;
  contract: ScheduleItemContract;
  isGroupRow: boolean;
  isChildRow: boolean;
  navigate: (path: string) => void;
}> = ({ scheduleItem, contract, isGroupRow, isChildRow, navigate }) => {
  if (isGroupRow && !isChildRow) {
    return (
      <span className={clsx(styles.tableText, styles.groupIndicator)}>Group of {scheduleItem.contracts.length}</span>
    );
  }

  return (
    <button className={styles.tableLink} onClick={() => navigate(`/contracts/${contract.id}`)}>
      {contract.contract_number}
    </button>
  );
};

export default ContractNumberCell;
